import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import '../App.css';
// import '../css/bootstrap.min.css';
// import '../css/demo.css';
// import '../css/material-kit.css';
import '../css/materialize.min.css';
// import '../css/general.css';
import './teenAI.css';
import {
  // BrowserRouter as Router,
  // Route,
  // Link,
  // Redirect,
} from 'react-router-dom';

class TeenAI extends Component {

  constructor(props) {
    super(props);
    this.state = {
      testRunning: false,
      messages: [],
      loading: false,
      // messages: [
      //   {creator: "other", message: "lorem ispliasdnas asdjkasdio1 as dasd iasd as ispliasdnas asdjkasdio1 as dasd ia ispliasdnas asdjkasdio1 as dasd ia", time: "20:17"},
      //   {creator: "self", message: "lorem ispliasdnas asdjkasdio1 as dasd iasd as ispliasdnas asdjkasdio1 as dasd ia", time: "20:17"},
      //   {creator: "other", message: "lorem ispliasdnas asdjkasdio1 as dasd iasd as", time: "20:17"},
      //   {creator: "self", message: "lorem ispliasdnas asdjkasdio1 as dasd iasd as", time: "20:17"},
      //   {creator: "other", message: "lorem ispliasdnas asdjkasdio1 as dasd iasd as", time: "20:17"},
      //   {creator: "self", message: "lorem ispliasdnas asdjkasdio1 as dasd iasd as ispliasdnas asdjkasdio1 as dasd iaispliasdnas asdjkasdio1 as dasd ia", time: "20:17"},
      //   {creator: "other", message: "lorem ispliasdnas asdjkasdio1 as dasd iasd as", time: "20:17"},
      //   {creator: "self", message: "lorem ispliasdnas asdjkasdio1 as dasd iasd as ispliasdnas asdjkasdio1 as dasd ia ispliasdnas asdjkasdio1 as dasd ia ispliasdnas asdjkasdio1 as dasd ia", time: "20:17"},
      // ]
    };

    this.messagesEnd = false;
    this.teenAnswerTimeout = null;
    this.randomTimeReply = null;
    this.prevLength = -1;
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.testRunning && this.messagesEnd) {
      this._scrollToBottom();
    }
    this._teenAI(prevProps, prevState);
  }

  _initiateRandomTimeReply = () => {
    if (this.randomTimeReply) clearTimeout(this.randomTimeReply);
    this.randomTimeReply = setTimeout(() => {
      this.setState((prevS, props) => {
        // let mess = Object.assign({}, prevState.messages);
        if (this.prevLength < prevS.messages.length) { // DON'T DO TWO IN A ROW
          const ms = prevS.messages.concat([{
            creator: "other",
            message: this._getMessageFromArray(teenMessages, Math.floor(Math.random() * teenMessages.length)), // this._getTeenMessage(prevS),
            time: this._timeNow(),
          }]);
          this.prevLength = prevS.messages.length + 1;
          return {
            messages: ms,
          };
        }
      });
      this._initiateRandomTimeReply();
    }, Math.floor(10000 + Math.random() * 30000) );
  }

  _getMessageFromArray = (array, index) => {
    return array.splice(index, 1);
  }

  _getConcatStringOfLastMessages = (state, who = "self") => {
    let greatestIndex = null;
    let leastIndex = null;

    let string = "";

    for (let i = state.messages.length - 1; i >= 0; i --) {
      const m = state.messages[i];
      if (greatestIndex === null && m.creator === "self") {
        greatestIndex = i;
      }
      if (greatestIndex !== null && leastIndex === null && m.creator === "other") {
        leastIndex = i + 1;
      }
      if (greatestIndex !== null && leastIndex === null) {
        string += " " + m.message;
      }

    }
    return string;
  }

  _getTeenMessage = (prevState) => {
    const numMessages = prevState.messages.length;
    if (prevState.messages.filter(m => m.creator === "other").length === 0) {
      return this._getMessageFromArray(starterMessages, Math.floor(Math.random() * starterMessages.length));
    } else {
      let messagesToTakeFrom = teenMessages;
      const selfMessages = prevState.messages.filter(m => m.creator === "self");
      const lastSelfSingleMessage = selfMessages[selfMessages.length - 1].message;
      const lastSelfMessage = this._getConcatStringOfLastMessages(prevState, "self");

      // console.log(lastSelfMessage);
      // console.log("lastSelfMessage", lastSelfMessage);

      const listsToTakeFrom = [];

      if (lastSelfMessage.includes("fuck") || lastSelfMessage.includes("fuuck")) {
        // messagesToTakeFrom = fuckMessages;
        listsToTakeFrom.push(fuckMessages);
      } // else
      if (lastSelfMessage.includes("?") && numMessages > 2) {
        // messagesToTakeFrom = questionsMessages;
        listsToTakeFrom.push(questionsMessages);
      } // else
      if (lastSelfMessage.includes("haha") || lastSelfMessage.includes("hihi") || lastSelfMessage.includes("hehe")) {
        // messagesToTakeFrom = laughterReponses;
        listsToTakeFrom.push(laughterReponses);
      } // else
      if (lastSelfSingleMessage.length < 4 && numMessages > 2 && !lastSelfMessage.includes("yes")) {
        // messagesToTakeFrom = shortReponses;
        listsToTakeFrom.push(shortReponses);
      }

      let messageString = "";

      for (let i = 0; i < listsToTakeFrom.length; i ++) {
        const list = listsToTakeFrom[i];
        if (list.length > 0) {
          if (i > 0) messageString += conjuctions[Math.floor(Math.random() * conjuctions.length)];
          messageString += this._getMessageFromArray(list, Math.floor(Math.random() * list.length));
        }
      }

      if (messageString.length > 0) {
        return messageString;
      } else {
        if (teenMessages.length > 0) return this._getMessageFromArray(teenMessages, Math.floor(Math.random() * teenMessages.length));
        return this._getMessageFromArray(endingMessages, Math.floor(Math.random() * endingMessages.length));
      }

      // if (messagesToTakeFrom.length > 0) {
      //   return this._getMessageFromArray(messagesToTakeFrom, Math.floor(Math.random() * messagesToTakeFrom.length));
      // } else {
      //   if (teenMessages.length > 0) return this._getMessageFromArray(teenMessages, Math.floor(Math.random() * teenMessages.length));
      //   return this._getMessageFromArray(endingMessages, Math.floor(Math.random() * endingMessages.length));
      // }
    }

  }

  _teenAI = (prevProps, prevState) => {
    if (Math.random() < 0.08) return; // Randomly not respond sometimes
    if (prevState.messages.length < this.state.messages.length && this.state.messages[this.state.messages.length-1].creator === "self") {
      if (this.teenAnswerTimeout) clearTimeout(this.teenAnswerTimeout);
      this.teenAnswerTimeout = setTimeout(() => {
        this.setState((prevS, props) => {
          // let mess = Object.assign({}, prevState.messages);
          const ms = prevS.messages.concat([{
            creator: "other",
            message: this._getTeenMessage(prevS),
            time: this._timeNow(),
          }]);
          return {
            messages: ms,
          };
        });
      }, Math.floor(1000 + Math.random() * 5000) );

    }
  }

  _toggleTest = () => {
    if (!this.state.testRunning) { // SHOW LOADING
      this.setState({
        loading: true,
      });
      setTimeout(() => {
        this.setState((prevS, props) => {
          this._initiateRandomTimeReply();
          return {
            loading: false,
            testRunning: !prevS.testRunning,
            value: "",
          };
        });
      }, Math.floor(2000 + Math.random() * 5000) );
    } else {
      // Should toggle here
    }

  }

  _timeNow = () => {
    var d = new Date(),
        h = (d.getHours()<10?'0':'') + d.getHours(),
        m = (d.getMinutes()<10?'0':'') + d.getMinutes(),
        s = (d.getSeconds()<10?'0':'') + d.getSeconds();
    return h + ':' + m + ':' + s;
  }

  _handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (this.state.value.length > 0) {
        this.setState((prevState, props) => {
          // let mess = Object.assign({}, prevState.messages);
          const ms = prevState.messages.concat([{
            creator: "self",
            message: prevState.value,
            time: this._timeNow(),
          }]);
          return {
            messages: ms,
            value: "",
          };
        });
      }
    }
  }

  _handleChange = (event) => {
    this.setState({
      value: event.target.value,
    })
  }

  _renderMessage = (message) => {
    return (
      <div className="msg" style={{
          backgroundColor: message.creator === "self" ? "#e6f9ff" : "white",
          width: 350,
          borderRadius: 5,
        }}>
        <p>{message.creator === "self" ? <b>YOU: </b> : <b>TEENAGER: </b>}{message.message}</p>
        <time>{message.time}</time>
      </div>
    );
  }

  _scrollToBottom = () => {
    const node = ReactDOM.findDOMNode(this.messagesEnd);
    node.scrollIntoView({ behavior: "smooth" });
  }

  _showTest = () => {
    let i = 0;
    const listItems = this.state.messages.map((message) => {
      i++;
      return (
        <li style={{width: "100%", display: "flex", borderRadius: 4,
            justifyContent: message.creator === "self" ? "flex-start" : "flex-end",
          }} className={message.creator}
          key={i}
        >
          { this._renderMessage(message) }
        </li>
      )
    });
    return (
      <div style={{width: 400, minHeight: "100vh", backgroundColor: "lightgrey", borderRadius: 4, display: "flex", paddingTop: 5}}>

        <ol className="chat" style={{
          padding: 5,
          paddingBottom: 80,
          minHeight: 200,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}>
          {/* <li
            style={{
              backgroundImage: "url('assets/img/teenager.jpg')", // `url(${background})`,
              height: 100,
              width: 150,
              marginLeft: "auto",
              marginRight: "auto",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right top",
              backgroundSize: "100%",
              borderRadius: 4,
            }} /> */ }
          {listItems}
          <li style={{ float:"left", clear: "both" }}
             ref={(el) => { this.messagesEnd = el; }} />
        </ol>

        <input onKeyPress={this._handleKeyPress}
          value={this.state.value} onChange={this._handleChange}
          style={{
            borderRadius: 4,
            backgroundColor: "white",
            paddingLeft: 10,
            paddingRight: 10,
            marginBottom: 40,
            maxWidth: 380}}
          className="textarea" type="text" placeholder="Type here!"/>
          {/* this._renderGuessBox() */}
      </div>
    )
  }

  _pressedGuess = (guess) => {

  }

  _renderGuessBox = () => {

    return (
      <div style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        fontWeight: "bold",
        position: "fixed",
        width: 400,
        bottom: 47,
        paddingLeft: 20,
        paddingRight: 20,
        backgroundColor: "lavender",
      }}>
        <div style={{fontWeight: "300"}}> GUESS? </div>
        <a className="waves-effect waves-light btn green"
          style={{color: "white"}}
        >REAL TEEN</a>
        <a className="waves-effect waves-light btn blue"
          style={{color: "white"}}
        >TEEN AI</a>
      </div>
    );
  }
  render() {
    // if (this.state.testRunning) return ;
    if (this.state.loading) {
      return (
        <div style={{
            // backgroundImage: "url('./assets/img/magicmike.jpg')", // `url(${background})`,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            backgroundColor: "orange",
            minHeight: "100vh",
            overflowY: "auto",
          }}
        >
          <div style={{maxWidth: 400}}>
            FINDING RANDOM TEENAGER ON THE INTERNET...
            <div className="progress">
                <div className="indeterminate"></div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div style={{
          // backgroundImage: "url('./assets/img/magicmike.jpg')", // `url(${background})`,
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          backgroundColor: "orange",
          minHeight: "100vh",
          overflowY: "auto",
        }}
      >
        {this.state.testRunning
        ?
          this._showTest()
        :
          <div style={{padding: 10, textAlign: "justify", maxWidth: "600px", alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "column"}}>
            <span style={{textAlign: "center"}}><h1>Teen 😫 AI</h1></span>
            <p style={{fontSize: 18}}>
              You will be connected to either a random 13 year old boy in America or to an Artificial Intelligence. Can you find out who’s who? That’s the <b>Turing test</b>, and if you cannot tell the difference, we have passed the test! Good luck...
            </p>
            <a className="waves-effect waves-light btn-large" style={{margin: 10}}onClick={() => this._toggleTest()}>START</a>
            <p style={{fontSize: 12, marginTop: 10}}>
              (OBS: The AI consists of a Deep Convolutional Long Short-term Memory Neural Network with 23 hidden layers and trained using dark data (unlabeled) from the internet and labeled by the DeepDive project)
            </p>
          </div>
        }

      </div>
    );
  }
}

// Check if message includes question mark
// Do a time out and wait if writes several questions
// Make sure no messages are asked twice
// If wrong, this is actually a 13 year old boy in New York who describes himself as: "A crazy gamer who loves pussy"
// teenageai.com
// problem is if several friends play and they get the same exact messages, they figure it out
// inlcude youtube links and other links
// Keywords "name", "fuck", "real", "old", "where"
// kep track of group taken last time, so they cannot find patterns
// Make all replys start in capital to make it look like phone messages?
// Randomly not respond and sometimes write something from nowhere
// Concat messags if several groups are triggered. Just seperate with period.
// Never have two messages come within less that 4 seks
// "nice" as a key word. It don't care about nice, i don't play nice, etc

const conjuctions = [
  ". ",
  ", ",
  ", and ",
  "& ",
  ".. ",
];

const teenagers = [
  "A crazy gamer who loves to party",
  "Do i have to fill this out?",
  "i'm here to help research so they can invente my future GF",
  "i'm just a troll, can't help it",
  "a nice guy, just a little bored",
  "13 year old aspiring programmer",
];

const laughterReponses = [
  "What's so funny?",
  "not funny..",
  "u think i'm funny?",
  "u think i'm joking around?",
  "is this some kind of joke to u? u sick person",
  "ur easily entertained",
  "i'm like a prof comedian or smthing",
  "hihihih",
  "gahaha",
  "funny right?",
  "i don't see why you would laugh at that",
  "😂.......",
]

const fuckMessages = [
  "do you mother know the kind of language you use",
  "nice dude",
  "'fuck' cool man",
  "no fuck u",
  "😍 fuck u too",
  "😘 fuck me plz",
  "😗 fuck uuuu",
  "😙 fuck off",
];

const questionsMessages = [
  "so many questions",
  "why should i answer that?",
  "u really want to know?",
  "????????? rigt back at ya",
];

const shortReponses = [
  "so verbose..",
  "...",
  // "is that an essay?",
  "that message is about as extended as ur most extended friend group",
  "please elaborate",
  // "easy now",
  // "✍️ ✍️ ✍️ ",
  "u have a way with words",
]

const starterMessages = [
  "well hello to u too..",
  "👋",
  "is this gonna take long?",
  "🖕",
  "i'm not gonna be to serious fyi",
  "fyi i do this cause my friend forced me",
  "off to a good start",
  "good, ur starting the conversation with confidence",
  "that's the best u could come up with?",
  "interesting conversation opener",
  "how u doooing?",
  "this is gonna be fun.......",
];

// When out of messages
const endingMessages = [
  "I'm outa here",
  "peace out",
  "nice chatting",
  "have a good life",
  "byyyyyyyye",
  "afk",
  "brb......... NOT",
  "wait, my mum is calling",
  "hey somebody's calling, gotta go",
  "hey somebody just broke into my house, gotta go",
  "i'd love to stay and chat, but i don't, so bye",
  "hope i never run into you on the internet again",
  "farewell my dear friend",
  "this was funnnnnnnnnnnn, byeee",
  "byebye",
];

const randomLinks = [

];

const emojis = [
  "😀",
  "😃",
  "😄",
  "😁",
  "😆",
  "😅",
  "😊",
  "😇",
  "🙂",
  "🙃",
  "😉",
  "😌",
  "😍",
  "😘",
  "😗",
  "😙",
];

const teenMessages = [
  "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  "how dare u?",
  "👵 boooring",
  "u make me 😴",
  "fuck 😎 off",
  "ur such a 🤓",
  "what are u wearing?",
  "Angsty",
  "K",
  "Do u lift?",
  "Whaaat",
  "fuck you",
  "fuck u",
  "fuck off",
  "duck u. god dammit auto correct",
  "whatever",
  "I’m just ignoring you",
  "that’s cool",
  "ok…",
  "who are u?",
  "are u famous?",
  "eh…",
  "lame",
  "this is lame",
  "are u on instagram?",
  "are u some kind of pervert",
  "afk",
  "you’re just pathetic",
  "?",
  "lol",
  "LOL",
  "< ( . , . ) > < - - - this is you",
  "(. )( .)",
  "3===D",
  "chill",
  "lana del ray, am i right?! ",
  "you’re a stranger, i don’t care about u",
  "...are you from america?",
  "what are u",
  "just stop",
  "brb, jk",
  "u have venmo? ",
  "do u have bitcoin?",
  "u smoke? ",
  "u female?",
  // "u male?",
  "fuck",
  "that’s what she said…",
  "I'd beat u in a fight, straight down",
  "i bet u are reaaaal lonely",
  "yes and no",
  "hihi",
  "interesting.............",
  "sooooo whaaaat",
  "yay",
  "ur famous?",
  "ur hot?",
  "ur single?",
  "idk about this",
  "what is this anyways",
  "drake's da shit",
  "There's vomit on his sweater already, mom's spaghetti",
  "Whole squad on that real shit",
  "u have $$$$$$$?",
  "where u from?",
  "are u a bot?",
  "is this a test?",
  "i'm da king of da internet",
  "GOAT right here u knoow",
  "Y so serious?",
  "FYI bernie sanders is my father",
  "TDLR; this was a mistake",
  "FYI i'm actually taking a dump rn",
  "Game of thrones, am i right or am i right?",
  "huh..",
  "enough of internet for today",
  "eh nevermind",
];

export default TeenAI;



// WEBPACK FOOTER //
// ./src/components/TeenAI.js